import { render, staticRenderFns } from "./CourseSectionView.vue?vue&type=template&id=53453d9c&"
import script from "./CourseSectionView.vue?vue&type=script&lang=js&"
export * from "./CourseSectionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports